// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore/lite';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCmPGy5ZTpcuzlq2-HNrDJM0B-eY37njFg",
    authDomain: "sunny-coast-skindivers-sign-on.firebaseapp.com",
    projectId: "sunny-coast-skindivers-sign-on",
    storageBucket: "sunny-coast-skindivers-sign-on.appspot.com",
    messagingSenderId: "1028296230687",
    appId: "1:1028296230687:web:ca8d96b2760cec6b6d122a"
};
// Initialize Firebase

const app = initializeApp(firebaseConfig);
// Export firestore database
// It will be imported into your react app whenever it is needed
export const db = getFirestore(app);